import React, { useState } from "react";
import SimpleReactValidator from "simple-react-validator";
import axios from "axios";
const ContactForm = (props) => {
  const [, forceUpdate] = useState(); // dummy state to trigger re-render
  const [successMessage, setSuccessMessage] = useState("");
  const [isSuccess, setIsSuccess] = useState(false);
  const [forms, setForms] = useState({
    name: "",
    email: "",
    company: "",
    phone: "",
    message: "",
  });
  const [validator] = useState(
    new SimpleReactValidator({
      className: "errorMessage",
    })
  );
  const changeHandler = (e) => {
    setForms({ ...forms, [e.target.name]: e.target.value });
    forceUpdate(1); // triggers re-render
    if (validator.allValid()) {
      validator.hideMessages();
    } else {
      validator.showMessages();
    }
  };

  const submitHandler = async (e) => {
    e.preventDefault();
    if (!validator.allValid()) {
      validator.showMessages();
      forceUpdate(1); // This will re-render to show errors
      return; // ⛔ Don't continue
    }
    if (validator.allValid()) {
      validator.hideMessages();
      setForms({
        name: "",
        email: "",
        company: "",
        phone: "",
        message: "",
      });
    } else {
      validator.showMessages();
    }
    const data = {
      name: forms.name,
      email: forms.email,
      company: forms.company,
      phone: forms.phone,
      message: forms.message,
    };
    console.log(data);

    try {
      const response = await axios.post(
        "https://apeitsolutions.com/contact_api.php",
        JSON.stringify(data)
      );
      setSuccessMessage(response.data.message);
      setIsSuccess(true);
      console.log(response);
    } catch (error) {
      console.log(error, "error");
      setSuccessMessage("Something went wrong. Please try again.");
      setIsSuccess(false);
    }
  };

  return (
    <form onSubmit={(e) => submitHandler(e)}>
      <div className="row">
        <div className="col-md-6">
          <div className="form-group">
            <label className="input_title" htmlFor="input_name">
              Full Name
            </label>
            <input
              value={forms.name}
              type="text"
              name="name"
              className="form-control"
              onBlur={(e) => changeHandler(e)}
              onChange={(e) => changeHandler(e)}
              placeholder="Enter Full Name"
            />
            {validator.message("name", forms.name, "required|alpha_space")}
          </div>
        </div>
        <div className="col-md-6">
          <div className="form-group">
            <label className="input_title" htmlFor="input_email">
              Your Email
            </label>
            <input
              value={forms.email}
              type="email"
              name="email"
              className="form-control"
              onBlur={(e) => changeHandler(e)}
              onChange={(e) => changeHandler(e)}
              placeholder="Enter Email"
            />
            {validator.message("email", forms.email, "required|email")}
          </div>
        </div>
        <div className="col-md-6">
          <div className="form-group">
            <label className="input_title" htmlFor="input_company">
              Company Name
            </label>
            <input
              value={forms.company}
              type="text"
              name="company"
              className="form-control"
              onBlur={(e) => changeHandler(e)}
              onChange={(e) => changeHandler(e)}
              placeholder="Enter Company Name"
            />
            {validator.message(
              "company",
              forms.company,
              "required|alpha_space|min:3|max:100"
            )}
          </div>
        </div>
        <div className="col-md-6">
          <div className="form-group">
            <label className="input_title" htmlFor="input_phone">
              Phone Number
            </label>
            <input
              value={forms.phone}
              type="text"
              name="phone"
              className="form-control"
              onBlur={(e) => changeHandler(e)}
              onChange={(e) => changeHandler(e)}
              placeholder="Enter Your Number"
            />
            {validator.message("phone", forms.phone, "required|numeric")}
          </div>
        </div>
        <div className="col-12">
          <div className="form-group">
            <label className="input_title" htmlFor="input_textarea">
              Message
            </label>
            <textarea
              onBlur={(e) => changeHandler(e)}
              onChange={(e) => changeHandler(e)}
              value={forms.message}
              type="text"
              name="message"
              className="form-control"
              placeholder="How can we help you?"
            ></textarea>
            {validator.message("message", forms.message, "required")}
          </div>
          {successMessage && (
            <div
              className={`alert text-center ${
                isSuccess ? "alert-success" : "alert-danger"
              }`}
              role="alert"
            >
              {successMessage}
            </div>
          )}

          <button type="submit" className="btn btn-primary">
            <span className="btn_label" data-text="Send Message">
              Send Message
            </span>
            <span className="btn_icon">
              <i className="fa-solid fa-arrow-up-right"></i>
            </span>
          </button>
        </div>
      </div>
    </form>
  );
};

export default ContactForm;
